import React from "react";
import locale from "@bonliva-crm/locale";
import { Paper } from "@material-ui/core";
import { Body } from "@components";

export function MissingCustomerNumberError() {
  return (
    <Paper
      style={{
        padding: 16,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Body color="error">{locale.AddCustomerNumberToCreateBooking}</Body>
    </Paper>
  );
}
